<div
  class="max-w-screen-xl flex flex-wrap items-center justify-between mx-auto p-4"
>
  <a routerLink="/" class="flex items-center space-x-3 rtl:space-x-reverse">
    <img
      src="/assets/others/horizontalLogo.webp"
      class="h-8"
      alt="Genie Logo"
    />
  </a>

  <button
      type="button"
      class="focus:outline-none md:hidden"
      (click)="toggleMenu()"
    >
      <img
        src="/assets/others/harmburger.webp"
        class="h-6 w-6"
        alt="Genie Logo"
      />
    </button>
</div>

<div class="container mx-auto">
  <div class="grid grid-cols-12 items-start p-4 md:gap-10">
    <div
      class="hidden col-span-3 space-y-3 md:flex flex-col py-10 sticky top-0"
    >
      <button
        *ngFor="let btn of buttons"
        (click)="updateView(btn.view)"
        class="p-4 rounded-xl text-black font-semibold"
        [ngClass]="{
          'shadow-[2px_2px_0px_0px_rgba(137,137,137,1)]  w-fit self-center text-white rounded text-lg px-6 py-1.5 text-center bg-tl-button-blue focus:outline-none disabled:opacity-50':
            currentView === btn.view
        }"
      >
        {{ btn.label }}
      </button>
    </div>

    <div
      class="md:col-span-9 col-span-12 bg-tl-grey shadow-2xl w-full rounded-xl"
    >
      @if (currentView === 'collaborators') {
      <div></div>
      }

      <!-- HELP START -->

      @if (currentView === 'help') {
      <div class="py-10 w-full">
        <div class="grid grid-cols-1 lg:grid-cols-12 gap-4 p-6">
          <!-- Query Section -->
          <form
            class="col-span-1 w-full md:col-span-6 rounded-lg"
            [formGroup]="queryForm"
            (ngSubmit)="submitQuery()"
          >
            <h2 class="text-lg font-semibold mb-4 text-black">Query:</h2>
            <textarea
              class="w-full h-40 text-black rounded-md p-2 bg-white shadow-[2px_2px_0px_0px_rgba(137,137,137,1)] focus:outline-none"
              placeholder="Type your message here"
              formControlName="message"
            ></textarea>
            @if(queryForm.get('message')?.touched &&
            queryForm.get('message')?.hasError('required')){
            <p><small class="text-red-500">Message is required.</small></p>
            }

            <button
              type="submit"
              class="disabled:opacity-70 font-semibold mt-4 shadow-[2px_2px_0px_0px_rgba(137,137,137,1)] w-fit self-center text-white rounded-[1.5rem] text-lg px-6 py-1.5 text-center bg-tl-button-blue focus:outline-none"
              [disabled]="queryForm.invalid"
            >
              Submit
            </button>
          </form>

          <!-- Contact Info Section -->
          <div
            class="col-span-1 w-full text-black rounded-lg font-semibold md:col-span-6 bg-tl-grey shadow-lg p-6"
          >
            <ul class="space-y-3">
              <li class="flex items-center">
                <svg
                  version="1.1"
                  id="Layer_1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  x="0px"
                  y="0px"
                  width="122.88px"
                  height="122.267px"
                  viewBox="0 0 122.88 122.267"
                  class="h-6 w-6 text-black"
                >
                  <g>
                    <path
                      fill="currentColor"
                      d="M33.822,50.291c4.137,7.442,8.898,14.604,15.074,21.133C55.1,77.984,62.782,83.962,72.771,89.03l0.01,0.005l0.002-0.005 c0.728,0.371,1.421,0.362,2.072,0.118c0.944-0.353,1.927-1.137,2.883-2.086c0.729-0.726,1.643-1.924,2.631-3.223 c3.846-5.054,8.601-11.301,15.314-8.193c0.142,0.065,0.276,0.141,0.402,0.226l22.373,12.852c0.08,0.046,0.157,0.095,0.23,0.147 c2.966,2.036,4.177,5.172,4.19,8.683c0.014,3.621-1.329,7.674-3.274,11.101c-2.565,4.517-6.387,7.502-10.761,9.525 c-4.17,1.928-8.798,2.954-13.267,3.608c-6.989,1.025-13.578,0.374-20.288-1.692c-6.55-2.017-13.176-5.385-20.4-9.86l-0.526-0.326 c-3.326-2.06-6.906-4.276-10.389-6.904C31.108,93.296,18.007,79.283,9.512,63.904C2.361,50.958-1.552,36.995,0.581,23.681 C1.75,16.375,4.901,9.743,10.333,5.35c4.762-3.853,11.188-5.94,19.448-5.203c0.973,0.084,1.793,0.639,2.255,1.419l0.006-0.003 l14.324,24.27c2.11,2.718,2.344,5.415,1.203,8.096c-0.943,2.218-2.892,4.251-5.476,6.168c-0.786,0.65-1.708,1.325-2.659,2.021 C36.236,44.459,32.578,47.136,33.822,50.291L33.822,50.291z M44.67,75.422C38.066,68.44,33.035,60.88,28.695,53.065 c-0.076-0.123-0.144-0.253-0.202-0.39c-3.174-7.459,2.52-11.625,7.493-15.262c0.845-0.618,1.663-1.217,2.401-1.829l0.002,0.003 c0.043-0.036,0.088-0.071,0.135-0.105c1.843-1.354,3.171-2.647,3.678-3.837c0.289-0.679,0.182-1.426-0.466-2.265 c-0.111-0.129-0.213-0.271-0.303-0.423L27.795,5.852c-5.869-0.241-10.419,1.321-13.784,4.044 c-4.239,3.429-6.723,8.759-7.674,14.699c-1.905,11.894,1.716,24.594,8.292,36.5c8.078,14.623,20.575,27.977,32.864,37.25 c3.379,2.55,6.776,4.653,9.932,6.607l0.526,0.326c6.818,4.223,13.017,7.386,19.052,9.244c5.876,1.809,11.634,2.38,17.729,1.486 c4.009-0.587,8.113-1.485,11.668-3.129c3.351-1.55,6.248-3.785,8.134-7.104c1.496-2.637,2.53-5.653,2.521-8.222 c-0.006-1.63-0.472-3.029-1.605-3.844L93.2,80.93c-2.461-1.081-5.629,3.081-8.193,6.45c-1.104,1.452-2.125,2.792-3.156,3.817 c-1.477,1.466-3.118,2.723-4.962,3.411c-2.136,0.799-4.395,0.834-6.755-0.37l0.002-0.004C59.522,88.849,51.323,82.457,44.67,75.422 L44.67,75.422z"
                    />
                  </g>
                </svg>
                <span class="ml-3">+91 9819460757</span>
              </li>
              <li class="flex items-center">
                <svg
                  version="1.1"
                  id="Layer_1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  x="0px"
                  y="0px"
                  width="122.879px"
                  height="88.855px"
                  viewBox="0 0 122.879 88.855"
                  class="h-6 w-6 text-black"
                >
                  <g>
                    <path
                      fill="currentColor"
                      d="M7.048,0h108.784c1.939,0,3.701,0.794,4.977,2.069c1.277,1.277,2.07,3.042,2.07,4.979v74.759 c0,1.461-0.451,2.822-1.221,3.951c-0.141,0.365-0.361,0.705-0.662,0.994c-0.201,0.189-0.422,0.344-0.656,0.461 c-1.225,1.021-2.799,1.643-4.508,1.643H7.048c-1.937,0-3.701-0.793-4.979-2.07C0.794,85.51,0,83.748,0,81.807V7.048 c0-1.941,0.792-3.704,2.068-4.979C3.344,0.792,5.107,0,7.048,0L7.048,0z M5.406,78.842l38.124-38.22L5.406,9.538V78.842 L5.406,78.842z M47.729,44.045L8.424,83.449h105.701L76.563,44.051L64.18,54.602l0,0c-0.971,0.83-2.425,0.877-3.453,0.043 L47.729,44.045L47.729,44.045z M80.674,40.549l36.799,38.598V9.198L80.674,40.549L80.674,40.549z M8.867,5.406l53.521,43.639 l51.223-43.639H8.867L8.867,5.406z"
                    />
                  </g>
                </svg>
                <span class="ml-3">contact&#64;talentlitmus.com</span>
              </li>
              <li class="flex items-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  shape-rendering="geometricPrecision"
                  text-rendering="geometricPrecision"
                  image-rendering="optimizeQuality"
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  viewBox="0 0 512 512"
                  class="h-6 w-6 text-black"
                >
                  <path
                    fill="#000"
                    d="M474.919 0H38.592C17.72 0 0 16.504 0 36.841V475.14C0 495.496 11.629 512 32.492 512h436.327C489.718 512 512 495.496 512 475.14V36.841C512 16.504 495.809 0 474.919 0zM195.043 195.043h68.928v35.136h.755c10.505-18.945 41.541-38.177 79.921-38.177 73.655 0 94.214 39.108 94.214 111.538v135.321h-73.148V316.883c0-32.427-12.947-60.883-43.227-60.883-36.768 0-54.295 24.889-54.295 65.758v117.103h-73.148V195.043zM73.139 438.861h73.148V195.043H73.139v243.818zm82.289-329.148c0 25.258-20.457 45.715-45.715 45.715-25.258 0-45.715-20.457-45.715-45.715 0-25.258 20.457-45.715 45.715-45.715 25.258 0 45.715 20.457 45.715 45.715z"
                  />
                </svg>
                <span class="ml-3 break-all"
                  >https://www.linkedin.com/company/talent-litmus</span
                >
              </li>
              <li class="flex items-center">
                <svg
                  version="1.1"
                  id="Layer_1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  x="0px"
                  y="0px"
                  viewBox="0 0 92.26 122.88"
                  class="h-6 w-6 text-black"
                >
                  <g>
                    <path
                      fill="currentColor"
                      d="M47.49,116.85c6.31-4.01,11.98-8.87,16.92-14.29c10.73-11.75,17.97-26.11,20.87-40.2c2.88-13.91,1.52-27.54-4.85-38.06 c-1.81-3.02-4.08-5.78-6.78-8.26c-7.74-7.05-16.6-10.41-25.52-10.5c-9.37-0.07-18.87,3.45-27.27,10.14 c-3.58,2.86-6.53,6.15-8.82,9.78c-5.9,9.28-7.69,20.8-5.74,32.85c1.97,12.23,7.78,25.02,17.04,36.61 c6.44,8.08,14.54,15.58,24.18,21.91L47.49,116.85L47.49,116.85z M46.13,21.16c7.05,0,13.45,2.86,18.06,7.49 c4.63,4.63,7.49,11,7.49,18.06c0,7.05-2.86,13.45-7.49,18.06c-4.63,4.63-11,7.49-18.06,7.49c-7.05,0-13.45-2.86-18.06-7.49 c-4.63-4.63-7.49-11-7.49-18.06c0-7.05,2.86-13.45,7.49-18.06C32.7,24.02,39.07,21.16,46.13,21.16L46.13,21.16z M60.51,32.33 c-3.67-3.67-8.78-5.97-14.38-5.97c-5.63,0-10.71,2.27-14.38,5.97c-3.67,3.67-5.97,8.78-5.97,14.38c0,5.63,2.27,10.71,5.97,14.38 c3.67,3.67,8.78,5.97,14.38,5.97c5.63,0,10.71-2.27,14.38-5.97c3.67-3.67,5.97-8.78,5.97-14.38C66.47,41.08,64.21,36,60.51,32.33 L60.51,32.33z M68.52,106.27c-5.6,6.12-12.09,11.61-19.42,16.06c-0.88,0.66-2.13,0.75-3.13,0.11 c-10.8-6.87-19.85-15.13-26.99-24.09C9.15,86.02,2.94,72.34,0.83,59.16c-2.15-13.36-0.14-26.2,6.51-36.68 c2.63-4.13,5.97-7.89,10.07-11.14C26.78,3.88,37.51-0.07,48.17,0c10.28,0.09,20.42,3.9,29.22,11.93c3.09,2.81,5.67,5.99,7.78,9.48 c7.15,11.77,8.69,26.81,5.56,42.01c-3.11,15.04-10.8,30.33-22.18,42.8L68.52,106.27L68.52,106.27z"
                    />
                  </g>
                </svg>
                <span class="ml-3">
                  Talent Litmus<br />
                  1, Hari Kunj, 633, P.D Hinduja Marg, Khar (W)<br />
                  Mumbai - 400 052
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      }
      <!-- HELP END -->

      @if(currentView === 'password'){
      <div
        class="container text-black"
        style="padding: 20px; max-width: 400px; margin: 0 auto"
      >
        <h2 class="mb-4 font-bold text-lg">
          To change your password, please fill in the fields below.
        </h2>

        <form [formGroup]="passwordForm" (ngSubmit)="changePassword()">
          <div class="form-group" style="margin-bottom: 20px">
            <label for="currentPassword" class="font-semibold"
              >Current Password</label
            >
            <input
              id="currentPassword"
              type="password"
              formControlName="currentPassword"
              class="w-full text-black rounded-md p-2 bg-white shadow-[2px_2px_0px_0px_rgba(137,137,137,1)] focus:outline-none"
            />
            <div
              *ngIf="
                passwordForm.controls['currentPassword'].invalid &&
                passwordForm.controls['currentPassword'].touched
              "
              class="text-xs mt-2 text-red-500"
            >
              Current password is required.
            </div>
            <!-- <a href="#" style="color: #ff6666; font-size: 12px; text-decoration: none;">Forgot your password?</a> -->
          </div>

          <div class="form-group" style="margin-bottom: 20px">
            <label for="newPassword" class="font-semibold">New Password</label>
            <input
              id="newPassword"
              type="password"
              formControlName="newPassword"
              class="w-full text-black rounded-md p-2 bg-white shadow-[2px_2px_0px_0px_rgba(137,137,137,1)] focus:outline-none"
            />
            <div class="mt-2 text-xs">
              <div class="flex items-center gap-2 mb-1">
                <div class="w-full bg-gray-200 rounded h-2 overflow-hidden">
                  <div
                    class="h-2"
                    [ngClass]="{
                      'bg-red-500': passwordStrengthScore <= 2,
                      'bg-yellow-500': passwordStrengthScore === 3,
                      'bg-green-500': passwordStrengthScore >= 4
                    }"
                    [style.width.%]="(passwordStrengthScore / 5) * 100"
                  ></div>
                </div>
                <span class="ml-2 text-black">{{ passwordStrengthLabel }}</span>
              </div>
              <ul class="list-disc ml-5 space-y-1 text-black">
                <li [ngClass]="{ 'text-green-600': passwordLengthOk, 'text-red-500': !passwordLengthOk }">
                  Minimum 8 characters
                </li>
                <li [ngClass]="{ 'text-green-600': passwordHasUpper && passwordHasLower, 'text-red-500': !(passwordHasUpper && passwordHasLower) }">
                  At least one uppercase and one lowercase letter
                </li>
                <li [ngClass]="{ 'text-green-600': passwordHasDigit, 'text-red-500': !passwordHasDigit }">
                  At least one digit
                </li>
                <li [ngClass]="{ 'text-green-600': passwordHasSpecial, 'text-red-500': !passwordHasSpecial }">
                  At least one special character
                </li>
              </ul>
              <div
                *ngIf="passwordForm.get('newPassword')?.touched && passwordForm.get('newPassword')?.invalid"
                class="text-red-500 mt-2"
              >
                <small *ngIf="passwordForm.get('newPassword')?.hasError('required')">New password is required.</small>
                <small *ngIf="passwordForm.get('newPassword')?.hasError('minlength')">Must be at least 8 characters.</small>
                <small *ngIf="passwordForm.get('newPassword')?.hasError('pattern')">Must include upper, lower, number, and special character.</small>
              </div>
            </div>
          </div>

          <div class="form-group" style="margin-bottom: 20px">
            <label for="confirmPassword" class="font-semibold"
              >Confirm New Password</label
            >
            <input
              id="confirmPassword"
              type="password"
              formControlName="confirmPassword"
              class="w-full text-black rounded-md p-2 bg-white shadow-[2px_2px_0px_0px_rgba(137,137,137,1)] focus:outline-none"
            />
            <div
              *ngIf="
                passwordForm.controls['confirmPassword'].invalid &&
                passwordForm.controls['confirmPassword'].touched
              "
              class="text-red-500 text-xs mt-2"
            >
              {{ passwordForm.errors?.["match_error"] }}
            </div>
          </div>

          <button
            [disabled]="isChagingPassword || passwordForm.invalid"
            type="submit"
            class="shadow-[2px_2px_0px_0px_rgba(137,137,137,1)] font-semibold w-fit self-center text-white rounded-[1.5rem] text-lg px-6 py-1.5 text-center bg-tl-button-blue focus:outline-none disabled:opacity-70"
          >
            Create new password
          </button>
        </form>
      </div>

      }

      <!-- Collaborators -->


      
      @if(currentView === 'collaborators'){ 
        
        
        @if(selectedCollaboratorId!==null){
      <form
        [formGroup]="resetPasswordForm"
        (ngSubmit)="onResetPassword()"
        class="p-10"
      >
        <button
          class="bg-tl-red w-10 h-10 rounded-full"
          (click)="closeResetPassword()"
        >
          X
        </button>
        <div
          class="max-w-md mx-auto text-white p-6 rounded-lg shadow-md space-y-4"
        >
          <!-- New Password Field -->
          <div>
            <label for="new-password" class="block text-black font-semibold"
              >New Password</label
            >
            <input
              id="new-password"
              type="password"
              formControlName="newPassword"
              class="w-full text-black rounded-md p-2 bg-white shadow-[2px_2px_0px_0px_rgba(137,137,137,1)] focus:outline-none"
              required
            />
            <div class="mt-2 text-xs">
              <div class="flex items-center gap-2 mb-1">
                <div class="w-full bg-gray-200 rounded h-2 overflow-hidden">
                  <div
                    class="h-2"
                    [ngClass]="{
                      'bg-red-500': resetPasswordStrengthScore <= 2,
                      'bg-yellow-500': resetPasswordStrengthScore === 3,
                      'bg-green-500': resetPasswordStrengthScore >= 4
                    }"
                    [style.width.%]="(resetPasswordStrengthScore / 5) * 100"
                  ></div>
                </div>
                <span class="ml-2 text-black">{{ resetPasswordStrengthLabel }}</span>
              </div>
              <ul class="list-disc ml-5 space-y-1 text-black">
                <li [ngClass]="{ 'text-green-600': resetPasswordLengthOk, 'text-red-500': !resetPasswordLengthOk }">
                  Minimum 8 characters
                </li>
                <li [ngClass]="{ 'text-green-600': resetPasswordHasUpper && resetPasswordHasLower, 'text-red-500': !(resetPasswordHasUpper && resetPasswordHasLower) }">
                  At least one uppercase and one lowercase letter
                </li>
                <li [ngClass]="{ 'text-green-600': resetPasswordHasDigit, 'text-red-500': !resetPasswordHasDigit }">
                  At least one digit
                </li>
                <li [ngClass]="{ 'text-green-600': resetPasswordHasSpecial, 'text-red-500': !resetPasswordHasSpecial }">
                  At least one special character
                </li>
              </ul>
              <div
                *ngIf="resetPasswordForm.get('newPassword')?.touched && resetPasswordForm.get('newPassword')?.invalid"
                class="text-red-500 mt-2"
              >
                <small *ngIf="resetPasswordForm.get('newPassword')?.hasError('required')">New password is required.</small>
                <small *ngIf="resetPasswordForm.get('newPassword')?.hasError('minlength')">Must be at least 8 characters.</small>
                <small *ngIf="resetPasswordForm.get('newPassword')?.hasError('pattern')">Must include upper, lower, number, and special character.</small>
              </div>
            </div>
            <div
              *ngIf="
                resetPasswordForm.controls['newPassword'].invalid &&
                resetPasswordForm.controls['newPassword'].touched
              "
              class="text-red-500 text-sm mt-1"
            >
              password is required.
            </div>
          </div>

          <!-- Confirm Password Field -->
          <div>
            <label for="confirm-password" class="block text-black font-semibold"
              >Confirm Password</label
            >
            <input
              id="confirm-password"
              type="password"
              formControlName="confirmPassword"
              class="w-full text-black rounded-md p-2 bg-white shadow-[2px_2px_0px_0px_rgba(137,137,137,1)] focus:outline-none"
              required
            />
            <div
              *ngIf="
                resetPasswordForm.controls['confirmPassword'].invalid &&
                resetPasswordForm.controls['confirmPassword'].touched
              "
              class="text-red-500 text-sm mt-1"
            >
              {{ resetPasswordForm.errors?.["match_error"] }}
            </div>
          </div>

          <!-- Submit Button -->
          <button
            type="submit"
            class="shadow-[2px_2px_0px_0px_rgba(137,137,137,1)] w-fit self-center text-white font-semibold rounded-[1.5rem] text-lg px-4 py-1.5 text-center bg-tl-button-blue focus:outline-none disabled:opacity-70"
                    [disabled]="resetPasswordForm.invalid || loading === 'reset'"
          >
            {{ loading === 'reset' ? 'Resetting' : 'Reset Password' }}
          </button>
        </div>
      </form>

      }
      
      

         @if(editCollaborator!==null){
      <div  class="mt-4 p-6 rounded-lg">


           <button
          class="bg-tl-red w-10 h-10 rounded-full"
          (click)="closeResetPassword()"
        >
          X
        </button>

          <form
            [formGroup]="collaboratorForm"
            (ngSubmit)="submitCollaborator()"
          >

               <div
          class="max-w-md mx-auto text-white p-6 rounded-lg shadow-md space-y-4"
        >
            <div class="form-group" style="margin-bottom: 20px">
              <label class="block text-black font-semibold">Name</label>
              <input
                type="text"
                formControlName="name"
                class="w-full text-black rounded-md p-2 bg-white shadow-[2px_2px_0px_0px_rgba(137,137,137,1)] focus:outline-none"
              />
              <div
                *ngIf="
                  collaboratorForm.get('name')?.invalid &&
                  collaboratorForm.get('name')?.touched
                "
              >
                <small class="text-red-500">Name is required.</small>
              </div>
            </div>

            <div class="form-group" style="margin-bottom: 20px">
              <label class="block text-black font-semibold">Email</label>
              <input
                type="email"
                formControlName="email"
                class="w-full text-black rounded-md p-2 bg-white shadow-[2px_2px_0px_0px_rgba(137,137,137,1)] focus:outline-none"
              />
              <div
                *ngIf="
                  collaboratorForm.get('email')?.invalid &&
                  collaboratorForm.get('email')?.touched
                "
              >
                <small class="text-red-500">A valid email is required.</small>
              </div>
            </div>

            <button
              type="submit"
              [disabled]="loading === 'add'"
              class="shadow-[2px_2px_0px_0px_rgba(137,137,137,1)] w-fit self-center text-white rounded-[1.5rem] text-lg px-6 py-1.5 text-center bg-tl-button-blue focus:outline-none disabled:opacity-50"
            >
              {{
                loading === 'add' ? 'Editing Collaborator' : 'Edit Collaborator'
              }}
            </button>
            </div>
            
          </form>
        </div>
      }
      

      @if(!selectedCollaboratorId && !editCollaborator){
      <div class="p-6 w-full">
        <h2 class="text-lg font-semibold text-black mb-4">Collaborators</h2>

        <!-- Add Collaborator Button -->
        <button
          class="shadow-[2px_2px_0px_0px_rgba(137,137,137,1)] cursor-pointer w-fit self-center text-white font-semibold rounded-[1.5rem] text-lg px-6 py-1.5 text-center bg-tl-red focus:outline-none disabled:opacity-50"
          (click)="toggleCollaboratorForm()"
        >
          {{ showCollaboratorForm ? 'Back' : 'Add Collaborator' }}
        </button>

        <!-- Add Collaborator Form -->
        <div *ngIf="showCollaboratorForm" class="mt-4 p-6 rounded-lg">
          <form
            [formGroup]="collaboratorForm"
            (ngSubmit)="submitCollaborator()"
          >
            <div class="form-group" style="margin-bottom: 20px">
              <label class="block text-black font-semibold">Name</label>
              <input
                type="text"
                formControlName="name"
                class="w-full text-black rounded-md p-2 bg-white shadow-[2px_2px_0px_0px_rgba(137,137,137,1)] focus:outline-none"
              />
              <div
                *ngIf="
                  collaboratorForm.get('name')?.invalid &&
                  collaboratorForm.get('name')?.touched
                "
              >
                <small class="text-red-500">Name is required.</small>
              </div>
            </div>

            <div class="form-group" style="margin-bottom: 20px">
              <label class="block text-black font-semibold">Email</label>
              <input
                type="email"
                formControlName="email"
                class="w-full text-black rounded-md p-2 bg-white shadow-[2px_2px_0px_0px_rgba(137,137,137,1)] focus:outline-none"
              />
              <div
                *ngIf="
                  collaboratorForm.get('email')?.invalid &&
                  collaboratorForm.get('email')?.touched
                "
              >
                <small class="text-red-500">A valid email is required.</small>
              </div>
            </div>

            <button
              type="submit"
              [disabled]="loading === 'add'"
              class="shadow-[2px_2px_0px_0px_rgba(137,137,137,1)] w-fit self-center text-white rounded-[1.5rem] text-lg px-6 py-1.5 text-center bg-tl-button-blue focus:outline-none disabled:opacity-50"
            >
              {{
                loading === 'add' ? 'Adding Collaborator' : 'Add Collaborator'
              }}
            </button>
          </form>
        </div>

        @if(!showCollaboratorForm){

        <div class="w-full border border-slate-200 rounded-xl mt-10 overflow-x-auto">
          <table class="w-full divide-y divide-slate-200 whitespace-nowrap">
            <thead class="bg-slate-100 text-slate-800">
              <tr>
                <th class="px-4 py-2 text-start">Name</th>
                <th class="px-4 py-2 text-start">Email</th>
                <th class="px-4 py-2 text-start">Role</th>
                <th class="px-4 py-2 text-start">Action</th>
              </tr>
            </thead>
            <tbody class="divide-y divide-slate-200 bg-white text-slate-800">
              <tr
                class="hover:bg-slate-100 font-semibold text-sm odd:bg-white even:bg-slate-50"
                *ngFor="let collaborator of collaborators"
              >
                <td class="px-4 py-2">{{ collaborator.name }}</td>
                <td class="px-4 py-2">{{ collaborator.email }}</td>
                <td class="px-4 py-2">{{ collaborator.role }}</td>
                <td class="px-4 py-2">
                  <div class="flex items-center gap-3">
                    <button
                      class="shadow-[2px_2px_0px_0px_rgba(137,137,137,1)] w-fit text-white font-semibold rounded-[1.5rem] text-lg px-4 py-1.5 text-center bg-tl-button-blue focus:outline-none disabled:opacity-50"
                      (click)="openResetPasswordForm(collaborator)"
                    >
                      Reset Password
                    </button>
                    <button
                      [disabled]="loading === 'delete'"
                      (click)="deleteCollaborator(collaborator._id)"
                      class="shadow-[2px_2px_0px_0px_rgba(137,137,137,1)] w-fit text-white font-semibold rounded-[1.5rem] text-lg px-4 py-1.5 text-center bg-tl-red focus:outline-none disabled:opacity-50"
                    >
                      Delete
                    </button>
                    <button
                      (click)="openEditForm(collaborator)"
                      class="shadow-[2px_2px_0px_0px_rgba(137,137,137,1)] w-fit text-white font-semibold rounded-[1.5rem] text-lg px-4 py-1.5 text-center bg-tl-button-blue focus:outline-none disabled:opacity-50"
                    >
                      Edit
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        }
      </div>
      } } @if(currentView === 'subscription'){
      <div class="p-6 w-full">
        <h2 class="text-lg font-semibold text-black mb-4">Subscription</h2>

        <div
          class="w-full bg-red-500 border border-slate-200 rounded-xl mt-10 overflow-x-auto"
        >
          <table class="w-full divide-y divide-slate-200">
            <thead class="bg-slate-100 w-full text-slate-800">
              <tr>
                <th class="px-4 py-2 text-start">Start date</th>
                <th class="px-4 py-2 text-start">End date</th>
                <th class="px-4 py-2 text-start">Total games</th>
                <th class="px-4 py-2 text-start">Games used</th>
                <th class="px-4 py-2 text-start">Games remaining</th>
              </tr>
            </thead>
            <tbody class="divide-y divide-slate-200 bg-white text-slate-800">
              <tr
                class="hover:bg-slate-100 cursor-pointer odd:bg-white even:bg-slate-50"
              >
                <td class="px-4 py-2">
                  @if( subscriptionSettings?.subscription?.startDate){
                  {{
                    subscriptionSettings?.subscription?.startDate | date : 'mediumDate'
                  }}
                  }
                </td>
                <td class="px-4 py-2">
                  @if( subscriptionSettings?.subscription?.endDate){
                  {{
                    subscriptionSettings?.subscription?.endDate | date : 'mediumDate'
                  }}
                  }
                </td>
                    <td class="px-4 py-2 space-y-3 lg:space-y-0 lg:space-x-4">
                  {{ subscriptionSettings?.subscription?.gamesAvailable }}
                </td>
                <td class="px-4 py-2">
                  {{ subscriptionSettings?.subscription?.usage?.gamesUsed }}
                </td>
                <td class="px-4 py-2 space-y-3 lg:space-y-0 lg:space-x-4">
                  {{ (subscriptionSettings?.subscription?.gamesAvailable || 0) - (subscriptionSettings?.subscription?.usage?.gamesUsed || 0)}}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      }
    </div>
  </div>

  <!-- @if(showMenu){ -->
  <div
    class="fixed top-0 left-0 bg-gray-800 shadow-2xl p-6 -translate-x-[9999px] transition-all duration-500 ease-linear h-screen w-3/4"
    [ngClass]="{
      '!translate-x-0': showMenu
    }"
  >
    <button
      *ngFor="let btn of buttons"
      (click)="updateView(btn.view)"
      class="p-4 rounded-xl text-white w-full"
      [ngClass]="{
        'shadow-[2px_2px_0px_0px_rgba(137,137,137,1)]  w-fit self-center text-white rounded text-sm px-2 py-1.5 text-center bg-tl-button-blue focus:outline-none disabled:opacity-50':
          currentView === btn.view
      }"
    >
      {{ btn.label }}
    </button>
  </div>
  <!-- } -->
</div>
